import { IMergedStepsModel, IStepsModel, StatePriority } from "@app/views-interfaces";

export function compareSteps(a: IStepsModel | IMergedStepsModel, b: IStepsModel | IMergedStepsModel): number {
    const diff = StatePriority[a.State] - StatePriority[b.State];

    return diff !== 0 ? diff : a.Order - b.Order;
}
